export let ELightningUnit=function(ELightningUnit){ELightningUnit["BTC"]="btc";ELightningUnit["SATS"]="sats";return ELightningUnit;}({});